import { MOCKS_CONFIG } from '../configs'
import type { MocksSettings } from '../models'

export const saveMocksSettings = (settings: MocksSettings): void =>
  window.sessionStorage.setItem(MOCKS_CONFIG.storageKeyName, JSON.stringify(settings))
